<template>
  <span> {{regularStreamStart.date}} to {{regularStreamEnd.date}} {{regularStreamStart.time}}</span>
</template>

<script>
import MomentTZ from 'moment-timezone'

export default {
  name: 'streamtimes',
  computed: {
    regularStreamStart: function () {
      var moment = MomentTZ.tz(MomentTZ.tz('America/New_York').day('monday').hour(11).minutes(0).seconds(0), MomentTZ.tz.guess())
      return {
        date: moment.format('dddd'),
        time: moment.format('ha z')
      }
    },
    regularStreamEnd: function () {
      var moment = MomentTZ.tz(MomentTZ.tz('America/New_York').day('friday').hour(17).minutes(0).seconds(0), MomentTZ.tz.guess())
      return {
        date: moment.format('dddd'),
        time: moment.format('ha z')
      }
    }
  }
}
</script>

<style scoped lang="scss">
span {
  color: inherit;
}
</style>



// WEBPACK FOOTER //
// StreamTimes.vue?f3708b74